const { createPPGChart }= require('./src/charts/pulse-candle-chart.js')
const { createBPChart } = require('./src/charts/blood-pressure-candle-chart')
const { createGlucoseChart } = require('./src/charts/glucose-chart.js')
const { createRespoiratoryChart } = require('./src/charts/respiratory-candle-chart')
const { createSpO2Chart } = require('./src/charts/spo2-candle-chart')
const { createTempChart } = require('./src/charts/temperature-chart')
const { createWeightChart } = require('./src/charts/weight-bar-chart')
const { createStepsChart } = require('./src/charts/steps-chart')
const { createSleepChart } = require('./src/charts/sleep-chart')
const {createCaloriesChart} =require('./src/charts/calories-chart')
const {createHistogramBarChart} =require('./src/charts/histogram-bar-chart')
const {appendEcgChart} = require('./src/charts/ecg-chart')
const { queryMonthlyChartsEvents } = require('./src/queries/monthlyChartsEvents')
const { createHrvRMSSD_PulseChart } = require('./src/charts/hrv-rmsdd-pulse-chart.js')
const { createHrvLFHFChart } = require('./src/charts/hrv-lf-hf-chart')
const { createHeartRateChart } = require('./src/charts/heart-rate-chart.js')
const { createPWVChart } = require('./src/charts/pwv-chart.js')
const { setEcgConversionFactor } = require('./src/utils/converter')


printMsg = function() {
    console.log("This is a message from cs-charts-module");
  }

drawPPGChart = function(rawData,thresholds,onClick,width,height,unit,thresholdsStatus){
  return createPPGChart(rawData,thresholds,onClick,width,height,thresholdsStatus)
}

drawBloodPressureChart = function(systolic, systolic_manual, systolic_external, diastolic, diastolic_manual, diastolic_external,thresholds,onClick,width,height,units,thresholdsStatus){
  return createBPChart(systolic, systolic_manual, systolic_external, diastolic, diastolic_manual, diastolic_external, thresholds,onClick,width,height,thresholdsStatus)
}

drawRespoiratoryChart = function(rawData,thresholds,onClick,width,height,unit,thresholdsStatus){
  return createRespoiratoryChart(rawData,thresholds,onClick,width,height,thresholdsStatus)
}

drawSpO2Chart = function(rawData, manualData, externalData ,thresholds,onClick,width,height,unit,thresholdsStatus){
  return createSpO2Chart(rawData, manualData, externalData,thresholds,onClick,width,height,thresholdsStatus)
}

drawHistogramChart = function(rawData,thresholds,onClick,width,height,type){
  return createHistogramBarChart(rawData,thresholds,onClick,width,height,type)
}
drawAppendEcgChart=function(rawData,thresholds,onClick,width,height,type,isDetailedReport, fwVersion){
  let SvgArr =  appendEcgChart(rawData,thresholds,onClick,width,height,isDetailedReport, fwVersion)
return SvgArr
  
}
drawGlucoseChart = function(rawData, manualData,thresholds,onClick,width,height,glucose_unit,thresholdsStatus){
  return createGlucoseChart(rawData, manualData,thresholds,onClick,width,height,glucose_unit,thresholdsStatus)
}

drawTempChart = function(rawData, manualData, externalData, thresholds,onClick,width,height,temperature_unit,thresholdsStatus){
  return createTempChart(rawData, manualData, externalData, thresholds,onClick,width,height,temperature_unit,thresholdsStatus)
}

drawWeightChart = function(rawData, manualData,thresholds,onClick,width,height,weight_unit) {
  return createWeightChart(rawData, manualData,thresholds,onClick,width,height,weight_unit)
}

drawStepsChart = function(rawData, manualData,thresholds,onClick,width,height,weight_unit) {
  return createStepsChart(rawData, manualData,thresholds,onClick,width,height,weight_unit)
}

drawSleepChart = function(rawData, manualData,thresholds,onClick,width,height,weight_unit) {
  return createSleepChart(rawData, manualData,thresholds,onClick,width,height,weight_unit)
}

drawCaloriesChart = function(rawData, manualData,thresholds,onClick,width,height,weight_unit) {
  return createCaloriesChart(rawData, manualData,thresholds,onClick,width,height,weight_unit)
}

drawPWVChart = function(rawData, thresholds, onClick, width, height, weight_unit) {
  return createPWVChart(rawData, thresholds, onClick, width, height, weight_unit)
}

drawHrvChart = function(rawData, manualData, thresholds, onClick, width, height, weight_unit) {
  return createHrvRMSSD_PulseChart(rawData, width, height)
}

drawHrvLfHfChart = function(rawData, manualData, thresholds, onClick, width, height, weight_unit) {
  return createHrvLFHFChart(rawData, width, height)
}

drawHeartRateChart = function(rawData, thresholds, onClick, width, height, weight_unit) {
  return createHeartRateChart(rawData, width, height)
}

getMonthlyChartsEventsQuery = function(id, start, end){
  return queryMonthlyChartsEvents(id, start, end)
}

ecgConversionFactor = function(fwVersion) {
  return setEcgConversionFactor(fwVersion)
}

module.exports ={
  drawPPGChart,
  drawBloodPressureChart,
  drawGlucoseChart,
  drawRespoiratoryChart,
  drawSpO2Chart,
  drawTempChart,
  drawWeightChart,
  drawStepsChart,
  drawCaloriesChart,
  getMonthlyChartsEventsQuery,
  drawHistogramChart,
  drawAppendEcgChart,
  drawHrvChart,
  drawHrvLfHfChart,
  drawHeartRateChart,
  drawSleepChart,
  drawPWVChart,
  ecgConversionFactor,
}